export const SUBMIT_KEY_FOR_REACT_QUERY = 'SUBMIT_KEY_FOR_REACT_QUERY';
